import { Component, OnInit, OnChanges, HostListener, ElementRef, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DepartmentsHelpbuttonService } from 'src/app/services/helpbutton-services/departments-helpbutton-service/departments-helpbutton.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { CenterLite } from 'src/app/models/center-model/center-lite.model';

@Component({
  selector: 'app-helpbutton-department-info-card',
  templateUrl: './helpbutton-department-info-card.component.html',
  styleUrls: ['./helpbutton-department-info-card.component.scss']
})
export class HelpbuttonDepartmentInfoCardComponent implements OnInit, OnChanges {

  @Input() departmentInfo;
  editingLocked: boolean;
  centerInternalId: string;
  centerList: CenterLite[];
  basicDataForm = new FormGroup({
    departmentName: new FormControl({ value: '', disabled: true }, Validators.required),
    location: new FormControl({ value: '', disabled: true }),
    active: new FormControl({ value: '', disabled: true }),
    selectedCenter: new FormControl({ value: '', disabled: true }, Validators.required),
    assistance: new FormControl({ value: '', disabled: true }),
    videocall: new FormControl({ value: '', disabled: true }),
    voice: new FormControl({ value: '', disabled: true }),
    askName: new FormControl({ value: '', disabled: true })
  });
  constructor(private eRef: ElementRef,
    private userStorageService: UserStorageService,
    private departmentsService: DepartmentsHelpbuttonService,
    private snackbarService: SnackBarService) {
    this.editingLocked = true;
  }

  ngOnInit() {
    this.centerList = this.userStorageService.getCenterList();
  }

  ngOnChanges() {
    if (this.departmentInfo) {
      this.resetForm();
    }
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.eRef.nativeElement.contains(event.target)) {
    } else {
      if (event.path[0].className !== 'mat-option-text') {
        if (this.departmentInfo && !this.editingLocked) {
          this.resetForm();
          this.lockEdition();
        }
      }
    }
  }

  public lockEdition() {
    this.editingLocked = true;
    this.basicDataForm.get('active').disable();
    this.basicDataForm.get('departmentName').disable();
    this.basicDataForm.get('location').disable();
    this.basicDataForm.get('selectedCenter').disable();
    this.basicDataForm.get('assistance').disable();
    this.basicDataForm.get('videocall').disable();
    this.basicDataForm.get('voice').disable();
    this.basicDataForm.get('askName').disable();
  }

  public unlockEdition() {
    this.editingLocked = false;
    this.basicDataForm.get('active').enable();
    this.basicDataForm.get('departmentName').enable();
    this.basicDataForm.get('location').enable();
    this.basicDataForm.get('selectedCenter').enable();
    this.basicDataForm.get('assistance').enable();
    this.basicDataForm.get('videocall').enable();
    this.basicDataForm.get('voice').enable();
    this.basicDataForm.get('askName').enable();
  }
  public toggleEdition() {
    if (this.editingLocked) {
     this.unlockEdition();
    } else {
      const validation = this.validateForm();
      if (validation === true) {
        this.submitForm();
      } else {
        this.snackbarService.open(validation, 'error');
      }
    }
  }

  public setSelectedCenter() {
    if (this.departmentInfo && this.centerList  && this.centerList.length > 0) {
      for (const center of this.centerList) {
        if (center.InternalId === this.departmentInfo.CenterInternalId) {
          return center;
        }
      }
    } else {
      return null;
    }
  }

  public resetForm() {
    this.basicDataForm.patchValue({
      departmentName: this.departmentInfo.SectionName,
      location: this.departmentInfo.Location,
      active: this.departmentInfo.Active,
      selectedCenter: this.setSelectedCenter(),
      assistance: this.departmentInfo.HasPhysicalAssistance,
      videocall: this.departmentInfo.HasVideoconference,
      voice: this.departmentInfo.OnlyVoice,
      askName: this.departmentInfo.AskName
    });
  }

  public validateForm() {
    if (!this.basicDataForm.get('departmentName').valid) {
      return 'helpbutton-page.snackbar messages.name department error';
    } else if (!this.basicDataForm.get('selectedCenter').valid) {
      return 'helpbutton-page.snackbar messages.selected department staff error';
    } else {
      return true;
    }
  }

  public submitForm() {
    this.departmentsService.updateSection(this.basicDataForm.get('active').value, this.basicDataForm.get('selectedCenter').value.InternalId, this.basicDataForm.get('assistance').value, this.basicDataForm.get('videocall').value, this.basicDataForm.get('voice').value, this.departmentInfo.InternalId, this.basicDataForm.get('location').value, this.basicDataForm.get('departmentName').value, this.basicDataForm.get('askName').value).subscribe(
      (res) => {
        this.snackbarService.open('helpbutton-page.snackbar messages.update department success', 'success');
        this.departmentsService.refreshDepartment();
        this.lockEdition();
      },
      (error) => {
        this.snackbarService.open('helpbutton-page.snackbar messages.update department error', 'error');
      }
    );
  }

  public setPreselected(op1, op2) {
    if (op1 && op2) {
      return op1.InternalId === op2.InternalId;
    }
  }
}
